import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { CloudUpload } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import { compose } from 'redux';
import {
  data as docTypes, DINTER
} from '@lba-dev/package.local-globals/docTypes';
import { attachFile } from '@lba-dev/package.local-globals/utils';

import { withDisplaying, withLoading } from '../hoc';
import { uploadFile } from '../actions/dropbox';
import notifSystem from '../notifSystem';
import store from '../store';
import { closeDialog, setDialog } from '../actions/dialog';

const DropboxUpload = ({
  buttonName,
  type,
  style,
  color,
  upload,
  length = 1,
  underscoreId,
  id,
  path,
  disableSave,
  loading,
  setLoading,
  disabled,
  certificatType,
  getFile = e => e
}) => {

  const handleError = (errorMessage = 'Le fichier n\'a pas pu être ajouté') => {
    setLoading(false);
    notifSystem.error('Erreur', errorMessage);
  };

  const extractErrorMessage = (err) => {
    const errorData = err?.response?.data;
    return errorData?.message || errorData?.error ||
      err?.message || 'Le fichier n\'a pas pu être ajouté';
  };

  const toggleDisableSave = (value) => {
    if (typeof disableSave === 'function') {
      disableSave(value);
    }
  };

  const addFile = async (e) => {
    if (!e.target.files[0]) {
      return;
    }
    const file = e.target.files[0];
    e.target.value = '';

    try {
      const fileData = await attachFile(file);
      const { key } = docTypes.find(e => e._id === type) || {};
      const extension = ((/[^.]*$/)).exec(fileData.name);
      const time = new Date().getTime();
      const fileName = `${fileData.name
        .replace(`.${extension}`, '')}-${time}.${extension}`;
      const name = path === 'artisans'
        ? `${key}-${id}-${length}-${time}${extension ? `.${extension}` : ''}`
        : fileName;
      const fileBase64 = `data:${fileData.type};base64,${fileData.data}`;

      toggleDisableSave(true);
      await setLoading(true);

      const res = await uploadFile({
        type,
        fileName: name,
        file: fileBase64,
        baseName: `${type}-${id}`,
        underscoreId,
        path,
        certificatType
      });

      const data = res.body().data();
      if (data.status !== 'OK') {
        handleError(data.message || data.error);
        return;
      }

      setLoading(false);
      notifSystem.success('Upload', 'Le fichier a bien été ajouté');
      getFile(id, data.element);
      toggleDisableSave(false);
    } catch (err) {
      handleError(extractErrorMessage(err));
    }
  };

  const handleCategorieUpload = async (attachments, categories) => {
    store.dispatch(setDialog({
      name: 'LoadingDialog',
      open: true,
      dialogProps: { title: 'Importation des fichiers en cours' },
    }));

    try {
      await attachments.asyncForEach(async attachment => {
        try {
          await uploadFile({
            type,
            fileName: attachment.name,
            file: 'data:application/pdf;base64,'.concat(attachment.data),
            id,
            underscoreId,
            path,
            categories
          });
          notifSystem.success('Upload',
            `Le fichier ${attachment.name} a bien été ajouté`);
        } catch (err) {
          const errorMsg = extractErrorMessage(err);
          notifSystem.error('Erreur',
            `${errorMsg} (${attachment.name})`);
        }
      });

      store.dispatch(closeDialog());

      if (!attachments.length) {
        notifSystem.error('Erreur', 'Veuillez ajouter un fichier');
        return;
      }

      getFile(id);
      toggleDisableSave(false);
    } catch (err) {
      handleError(extractErrorMessage(err));
    }
  };

  const addFileCategorie = (e) => {
    e.stopPropagation();

    return store.dispatch(setDialog({
      name: 'DialogPrintfileTypes',
      open: true,
      dialogProps: { title: 'Documents présents dans le scan', middle: true },
      contentProps: {
        attachments: [],
        categories: []
      },
      actions: [
        {
          children: 'Ajouter',
          color: 'primary',
          onClick: ({ attachments, categories }) =>
            handleCategorieUpload(attachments, categories)
        }
      ],
    })
    );
  };

  return (
    <>
      {type === DINTER ?
        <Tooltip title="Taille maximale : 10 MB" placement="top" arrow>
          <Button
            variant="contained"
            component="span"
            color="primary"
            onClick={(e) => addFileCategorie(e)}
            disabled={disabled || loading}
            style={{ backgroundColor: color || null }}
          >
            {buttonName && (
              <div style={{ marginRight: 8 }} children={buttonName} />
            )}
            <CloudUpload style={{ fontSize: 20, marginRight: 5 }} />
            {loading && <CircularProgress size={24} />}
          </Button>
        </Tooltip> :
        <Grid style={style}>
          <input
            type="file"
            style={{ display: 'none' }}
            id={type}
            onChange={upload || addFile}
            disabled={disabled || loading}
          />
          <label htmlFor={type}>
            <Tooltip title="Taille maximale : 10 MB" placement="top" arrow>
              <Button
                variant="contained"
                component="span"
                color="primary"
                disabled={disabled || loading}
                style={{ backgroundColor: color || null }}
              >
                {buttonName && <div style={{ marginRight: 8 }}
                  children={buttonName} />}
                <CloudUpload style={{ fontSize: 20, marginRight: 5 }} />
                {loading && <CircularProgress size={24} />}
              </Button>
            </Tooltip>
          </label>
        </Grid>
      }
    </>
  );
};

DropboxUpload.displayName = 'DropboxUpload';

export default compose(
  withDisplaying(),
  withLoading({ customHandling: true })
)(DropboxUpload);
